import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// TargetChip.tsx — "where will Save write?", shown next to the Level Editor's Save/Publish buttons.
//
// The environment picker used to be a bar across the top of the panel, visible from every page. It
// moved into the Levels page's left column, which is right for choosing one — but the Level Editor
// is where a level is actually WRITTEN, and a write whose destination is off-screen is a blind
// action. This is the destination, stated where the decision is made.
//
// It also carries the attention pulse. Saving with nothing picked used to flash the top bar; with
// that bar gone the flash would land on a page the author is not looking at, leaving them with an
// error message and nothing to click.
import { Component } from "react";
import { targetStore, PRODUCTION_TARGET_ID } from "./targetStore";
export class TargetChip extends Component {
    constructor() {
        super(...arguments);
        this.state = { targetId: targetStore.id, pulsing: false, pulseToken: 0 };
        this.unsubscribe = null;
        this.unsubscribeAttention = null;
        this.pulseTimer = null;
        // pulseToken keys the element, so a second pulse landing mid-animation remounts it and visibly
        // restarts rather than relying on class churn. Same trick the old top bar used.
        this.pulse = () => {
            if (this.pulseTimer !== null) {
                window.clearTimeout(this.pulseTimer);
            }
            this.setState((s) => ({ pulsing: true, pulseToken: s.pulseToken + 1 }));
            this.pulseTimer = window.setTimeout(() => {
                this.setState({ pulsing: false });
                this.pulseTimer = null;
            }, 1000);
        };
    }
    componentDidMount() {
        this.unsubscribe = targetStore.subscribe(() => this.setState({ targetId: targetStore.id }));
        this.unsubscribeAttention = targetStore.subscribeAttention(this.pulse);
    }
    componentWillUnmount() {
        this.unsubscribe?.();
        this.unsubscribeAttention?.();
        if (this.pulseTimer !== null) {
            window.clearTimeout(this.pulseTimer);
        }
    }
    render() {
        const { targetId, pulsing, pulseToken } = this.state;
        const none = targetId === null;
        const isProduction = targetId === PRODUCTION_TARGET_ID;
        // ⚠ Three states told apart by WORDS first — "no environment", "DEFAULT", or the name —
        // with colour as reinforcement only. Which environment a Save lands in is the expensive
        // thing to get wrong here. ("Default" is the environment the game ships from — its id is
        // still "production" on the wire; only the wording changed, since prod-vs-dev is really
        // decided at Deploy time.)
        const tone = none
            ? "border-red-500/70 text-red-300"
            : isProduction
                ? "border-amber-500/60 text-amber-300"
                : "border-slate-600 text-slate-300";
        return (_jsxs("button", { type: "button", onClick: this.props.onPick, title: "Pick the environment Save and Publish write to (opens Levels)", className: "flex items-center gap-1.5 rounded-md border bg-slate-800 px-2 py-1 text-xs transition hover:bg-slate-700 " +
                tone +
                (pulsing ? " animate-attention ring-2 ring-red-500" : ""), children: [_jsx("span", { className: "uppercase tracking-wide text-slate-500", children: "to" }), none ? (_jsx("span", { className: "font-semibold", children: "no environment \u2014 pick one" })) : (_jsx("span", { className: "font-mono font-semibold", children: isProduction ? "DEFAULT" : targetId }))] }, pulseToken));
    }
}
